import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Button, Input, Form, Alert } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';

const LockScreen = () => {
    document.title = "Lockscreen | Rakops - Ticket Management System";

    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState({
        name: 'User',
        email: '',
        initial: 'U'
    });

    useEffect(() => {
        // Load user data from localStorage using the correct 'user' key
        const userDataString = localStorage.getItem("user");
        if (userDataString) {
            try {
                const user = JSON.parse(userDataString);
                setUserData({
                    name: user.name || 'User',
                    email: user.email || '',
                    initial: (user.name || 'U').charAt(0).toUpperCase()
                });
            } catch (error) {
                console.error("Error parsing user data:", error);
            }
        } else {
            // If no user in localStorage, redirect to login
            navigate('/login');
        }
    }, [navigate]);

    const handleUnlock = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            // Correctly passing email and password as separate arguments to match api.js
            const response = await authAPI.login(userData.email, password);

            if (response.data && response.data.token) {
                // Password is correct, restore token and user data
                localStorage.setItem('auth_token', response.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.user));
                localStorage.removeItem('isLocked');
                // Redirect to dashboard
                window.location.href = '/dashboard';
            }
        } catch (err) {
            console.error("Unlock error:", err);
            setError('Mot de passe incorrect. Veuillez réessayer.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <React.Fragment>
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="8" lg="6" xl="5">
                            <Card className="overflow-hidden">
                                <CardBody className="pt-0">
                                    <h3 className="text-center mt-5 mb-4">
                                        <Link to="/" className="d-block auth-logo">
                                            <span className="auth-logo-dark" style={{ fontSize: "28px", fontWeight: "bold", color: "#343a40" }}>Rakops</span>
                                            <span className="auth-logo-light" style={{ fontSize: "28px", fontWeight: "bold", color: "#fff" }}>Rakops</span>
                                        </Link>
                                    </h3>
                                    <div className="p-3">
                                        <h4 className="text-muted font-size-18 mb-1 text-center">Verrouillé</h4>
                                        <p className="text-muted text-center">Bonjour {userData.name}, entrez votre mot de passe pour déverrouiller!</p>

                                        {error && <Alert color="danger">{error}</Alert>}

                                        <Form className="form-horizontal mt-4" onSubmit={handleUnlock}>
                                            <div className="user-thumb text-center mb-4">
                                                <div className="rounded-circle avatar-md img-thumbnail mx-auto d-flex align-items-center justify-content-center bg-primary text-white" style={{ width: '80px', height: '80px', fontSize: '32px', fontWeight: 'bold' }}>
                                                    {userData.initial}
                                                </div>
                                                <h6 className="font-size-16 mt-3">{userData.name}</h6>
                                                <p className="text-muted small">{userData.email}</p>
                                            </div>

                                            <div className="mb-3">
                                                <label htmlFor="userpassword">Mot de passe</label>
                                                <Input
                                                    name="password"
                                                    className="form-control"
                                                    type="password"
                                                    placeholder="Entrez votre mot de passe"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="mb-3 row">
                                                <div className="col-12 text-end">
                                                    <Button
                                                        color="primary"
                                                        className="w-md waves-effect waves-light"
                                                        type="submit"
                                                        disabled={loading}
                                                    >
                                                        {loading ? 'Déverrouillage...' : 'Déverrouiller'}
                                                    </Button>
                                                </div>
                                            </div>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="mt-5 text-center">
                                <p>Pas vous ? retournez à la <Link to="/login" className=" text-primary">Connexion</Link> </p>
                                <p>© {new Date().getFullYear()} Rakops. Ticket Management System</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default LockScreen
